interface SailingProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "parts",
    name: "Name the parts of a sail",
    blurb:
      "A part of the mainsail is highlighted on the diagram — pick the name. Covers head, tack, clew, luff, leech, foot, batten, telltale, reef points, cringle, boom, mast, kicker, outhaul, halyard, sheet.",
  },
  {
    slug: "points",
    name: "Points of sail",
    blurb:
      "The boat sits at a heading on the points-of-sail compass — name the point of sail (in irons, close-hauled, close reach, beam reach, broad reach, run).",
  },
  {
    slug: "sequences",
    name: "Sail-handling sequences",
    blurb:
      "Tacking, gybing, reefing, heaving-to, capsize recovery — given the steps so far, pick what happens next. Covers the call-outs (Ready about, Lee-oh, Gybe-oh) and who does what (helm vs crew).",
  },
  {
    slug: "boat-parts",
    name: "Boat anatomy",
    blurb:
      "Name the part — yacht profile, standing & running rigging, powerboat profile, below-decks systems. Filter by scope to drill one view at a time, or 'All' to mix.",
  },
];

/// Sailing module hub. Reference content (labelled sail diagram +
/// points-of-sail compass) lives on the Reference tab; the drills
/// below get the vocabulary in.
export function Sailing({ onNavigate }: SailingProps) {
  return (
    <>
      <p className="muted">
        The vocabulary every sailor needs: parts of the sail and the
        boat's heading relative to the wind. Reference diagrams on
        the Reference tab; drills below to get the names down.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/sailing/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
